import React, { useState, useEffect, useRef, useCallback } from 'react';
// Build version: 2024-12-26-v1 - Display review note in screenshot
import ScoreChecker from './scoreChecker.js';

import { useLocation } from 'react-router-dom';


import { Routes, Route } from "react-router-dom";

import axios from 'axios';
import logo from './logo.svg';
import './App.css';
import io from 'socket.io-client';
import  OrderTable  from './LineItemsTable.js';
import styled from 'styled-components';

import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";

import OrderToAudio from './OrderToAudio.js';

import html2canvas from 'html2canvas';

// import TwilioPhone from './TwilioPhone'; 

import AudioMixer from './AudioMixer';

import POSComponent from './HeadlessPOS/POSComponent';


import {ShopifyProvider} from '@shopify/hydrogen-react';
import {CartProvider} from '@shopify/hydrogen-react';


// class ErrorBoundary extends Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, info) {
//     // Log error to monitoring service
//     console.log(error, info);
//   }

//   render() {
//     if (this.state.hasError) {
//       // You can render a fallback UI here
//       return <h1>Something went wrong.</h1>;
//     }

//     return this.props.children;
//   }
// }





const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;


const CoolBorder = styled.div`
  border: ${props => props.$border ? '1px solid red' : '1px solid #e0e0e0'}; /* A light border for that subtle charm */
  padding: 5px; /* Some breathing room */
  background-color: #fafafa; /* A background that's easy on the eyes */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* A touch of shadow for depth */
  background-color: rgba(255, 255, 255, 0.2); /* 50% transparency, 100% awesomeness */
  border-radius: 15px;
  margin: 10px;
`;

const OrderTableStyled = styled.div`
  max-width: 49%; // This allows for 2 components side by side with a 10px gap in between
  width: 100%;
  margin: 5px;
  @media (max-width: 600px) {
    max-width: 100%;
  }
`;
const StyledButton = styled.button`
    line-height: 1.5em;
    max-width: 75%;
    margin: 5px;
    font-size: 0.6em;
    font-weight: 500;
    padding: 10px;
    color: white;
    background: linear-gradient(to right, #007BFF, #0096FF);
    border: none;
    border-radius: 15px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: all 0.3s ease-out;
    position: relative;
    overflow: hidden;
    
    &:hover {
        box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
    }

    &:active {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        transform: translateY(4px);
    }

    @media (max-width: 600px) {
        width: 100%;
    }
`;

const ScoreContainer = styled.div`
  padding: 10px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.2); /* Consistent with CoolBorder */
`;

const TranscriptContainer = styled.div`
  padding: 15px;
  margin: 10px 0;
  width: 100%;
  max-width: 100%;
  flex: 0 0 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #fff8e1; /* Solid light yellow background for visibility in screenshots */
  border: 2px solid #ffc107; /* Gold border to highlight the transcript */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  & > p {
    margin: 5px;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    word-wrap: break-word;
    max-width: 100%;
  }
`;



const ScoreHeading = styled.h3`
  color: #007BFF; /* Picking up the blue from your gradient button */
  font-weight: 600;
  margin: 5px;
`;

const ScoreDetail = styled.p`
  color: #333; /* A darker text for contrast */
  font-size: 0.8em; /* Slightly smaller than the heading */
  margin: 2px 0; /* A little space between lines */
`;


const ReviewRequest = styled.p`
  font-size: 2em;
  font-weight: bold;
`;

const ReviewNoteContainer = styled.div`
  background-color: #fff3cd;
  border: 3px solid #ffc107;
  padding: 15px 20px;
  border-radius: 10px;
  margin: 10px 0 15px 0;
  width: 100%;
  box-sizing: border-box;
`;

const ReviewNoteTitle = styled.h3`
  color: #856404;
  margin: 0 0 10px 0;
  font-size: 1.2em;
  font-weight: 600;
`;

const ReviewNoteText = styled.p`
  font-size: 1.1em;
  font-weight: 500;
  color: #333;
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const TraineeInfoContainer = styled.div`
  background-color: #e3f2fd;
  border: 2px solid #2196f3;
  padding: 10px 15px;
  border-radius: 8px;
  margin: 10px 0;
`;

const TraineeInfoText = styled.p`
  font-size: 1em;
  color: #1565c0;
  margin: 5px 0;
`;

// Onboarding (no-orders-yet) Styled Components
const OnboardingCard = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 32px 36px;
  background: #ffffff;
  border: 2px solid #ffc107;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  color: #1a1a2e;
  text-align: left;
`;

const OnboardingTitle = styled.h2`
  margin: 0 0 8px 0;
  font-size: 1.6em;
  color: #b26a00;
`;

const OnboardingSubtitle = styled.p`
  margin: 0 0 20px 0;
  color: #555;
  font-size: 1em;
`;

const OnboardingStepList = styled.ol`
  margin: 0 0 24px 0;
  padding-left: 22px;
  color: #333;
  font-size: 1em;
  line-height: 1.55;

  li {
    margin-bottom: 10px;
  }

  strong {
    color: #1a1a2e;
  }
`;

const OnboardingActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
`;

const OnboardingPrimaryButton = styled.button`
  padding: 12px 22px;
  font-size: 1em;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #007BFF, #0056b3);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 123, 255, 0.35);
  }
`;

const OnboardingSecondaryButton = styled.button`
  padding: 12px 22px;
  font-size: 1em;
  font-weight: 500;
  color: #333;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
`;

// Review Modal Styled Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ModalTitle = styled.h2`
  margin: 0 0 8px 0;
  color: #1a1a2e;
  font-size: 1.5em;
  font-weight: 600;
`;

const ModalSubtitle = styled.p`
  margin: 0 0 24px 0;
  color: #666;
  font-size: 0.95em;
`;

const ModalTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 1em;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #007BFF;
    box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.1);
  }

  &::placeholder {
    color: #aaa;
  }
`;

const ModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  justify-content: flex-end;
`;

const ModalButton = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1em;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.$primary ? `
    background: linear-gradient(135deg, #007BFF, #0056b3);
    color: white;
    border: none;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  ` : `
    background: white;
    color: #666;
    border: 2px solid #e0e0e0;

    &:hover {
      background: #f5f5f5;
      border-color: #ccc;
    }
  `}
`;

const CharCount = styled.span`
  display: block;
  text-align: right;
  margin-top: 8px;
  font-size: 0.85em;
  color: ${props => props.$warning ? '#e74c3c' : '#999'};
`;


function App() {

  console.log("App() has run");
  const location = useLocation();
  const [comparisonResults, setComparisonResults] = useState([]);
  const [receiptPreviews, setReceiptPreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSocketConnected, setIsSocketConnected] = useState(false);
  const [recivedComparisonResults, setRecivedComparisonResults] = useState(false);
  const [requestStatuses, setRequestStatuses] = useState([]);
  const [copyStatusMessage, updateCopyStatus] = useState('📸 Copy to Signal');
  const [requireReview, setRequireReview] = useState(Array(comparisonResults.length).fill(false));
  const [reviewNotes, setReviewNotes] = useState(Array(comparisonResults.length).fill('')); // Trainee explanation for review
  const [isAudioMixer, setIsAudioMixer] = useState(false);

  // Review Modal State - v2
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewModalIndex, setReviewModalIndex] = useState(null);
  const [reviewModalNote, setReviewModalNote] = useState('');

  const [sessionId, setSessionId] = useState(null);
  const previousResultsRef = useRef([]);

  // Onboarding state for brand-new trainee accounts that have no orders yet.
  // Backend signals this with { noOrdersYet: true } in the comparisonResult payload.
  const [needsFirstOrder, setNeedsFirstOrder] = useState(false);
  const [onboardingInfo, setOnboardingInfo] = useState(null); // { customerId, customerTags, restaurantName }


  const simplifyingOrderData = (order, notMatchingData) => {
    if (!order) {
      console.log(`no data for rawOrder`);
      return { order: [], notMatchingData: [] };
    }
  

    const simplifiedOrder = {
      id: Number(order.legacyResourceId),
      name: order.name,
      created_at: order.createdAt,
      note: order.note,
      customer: {
        id: Number(order.customer.legacyResourceId),
        first_name: order.customer.firstName,
        last_name: order.customer.lastName || '',
        email: order.customer.email || '',
        default_address:{
          address1: order.customer.defaultAddress.address1,
          address2: order.customer.defaultAddress.address2,
          city: order.customer.defaultAddress.city,
          province_code: order.customer.defaultAddress.provinceCode,
          zip: order.customer.defaultAddress.zip,
          phone: order.customer.defaultAddress.phone
        }
      },
      shipping_address: order.shippingAddress 
      ? { last_name: order.shippingAddress.lastName } 
      : {},
      line_items: order.lineItems.edges.map(edge => {
        const isNotMatching = notMatchingData.some(item => item.node.id === edge.node.id);

        return {
          price: edge.node.originalUnitPriceSet.shopMoney.amount,
          quantity: edge.node.quantity,
          properties: edge.node.customAttributes.map(attribute => ({ name: attribute.key, value: attribute.value })),
          title: edge.node.title,
          variant_title: edge.node.variant ? (edge.node.variant.title === 'Default Title' ? null : edge.node.variant.title) : null,
          sku: edge.node.variant ? edge.node.variant.sku : null,
          isNotMatching: isNotMatching
        };
      }),
      subtotal_price: order.subtotalPriceSet.shopMoney.amount,
      total_tax: order.totalTaxSet.shopMoney.amount,
      total_price: order.totalPriceSet.shopMoney.amount,
      metafield: order.metafield
    };

    return { simplifiedOrder, notMatchingData };

  }  

  function sortLineItems(order) {
    if (!order || !order.line_items) {
      console.log("order.line_items is undefined");
      return order;
    }
    let sortedItems = [];
    let parentItems = {};
    let childItems = {};
  
    order.line_items.forEach(item => {
      let orderGroup = item.properties.find(prop => prop.name === '_io_order_group')?.value;
      let parentGroup = item.properties.find(prop => prop.name === '_io_parent_order_group')?.value;
  
      if (orderGroup && parentGroup) {
        throw new Error("Line item cannot have both _io_order_group and _io_parent_order_group");
      }
  
      if (orderGroup) {
        // Check if there are any child items waiting for this parent
        if (childItems[orderGroup]) {
          sortedItems.push(item, ...childItems[orderGroup]);
          delete childItems[orderGroup];
        } else {
          sortedItems.push(item);
        }
        parentItems[orderGroup] = item;
      } else if (parentGroup) {
        // Check if the parent item has already been added to sortedItems
        if (parentItems[parentGroup]) {
          // Insert this child item right after its parent
          let parentIndex = sortedItems.indexOf(parentItems[parentGroup]);
          sortedItems.splice(parentIndex + 1, 0, item);
        } else {
          // The parent item has not been encountered yet, so we add this to childItems
          if (!childItems[parentGroup]) childItems[parentGroup] = [];
          childItems[parentGroup].push(item);
        }
      } else {
        sortedItems.push(item);
      }
    });
  
    // Check if there are any remaining childItems that weren't included
    for (let group in childItems) {
      sortedItems.push(...childItems[group]);
    }
  
    order.line_items = sortedItems;
    return order;
  }
  
  const socket = useRef(null);


  useEffect(() => {
    setRequestStatuses(Array(comparisonResults.length).fill('idle'));
  }, [comparisonResults]);  

  useEffect(() => {
    const prevResults = previousResultsRef.current;
    const prevLength = prevResults.length;
    const nextLength = comparisonResults.length;

    if (prevLength !== nextLength) {
      const diff = nextLength - prevLength;
      const nextFirstId = comparisonResults[0]?.order1Data?.id;
      const nextLastId = comparisonResults[nextLength - 1]?.order1Data?.id;
      const prevFirstId = prevResults[0]?.order1Data?.id;
      const prevLastId = prevResults[prevLength - 1]?.order1Data?.id;
      const isPrepend = prevLength > 0 && nextLastId === prevLastId && nextFirstId !== prevFirstId;
      const isAppend = prevLength > 0 && nextFirstId === prevFirstId && nextLastId !== prevLastId;

      const adjustArray = (prevArray, defaultValue) => {
        if (nextLength < prevArray.length) {
          return prevArray.slice(0, nextLength);
        }
        if (prevLength === 0) {
          return Array(nextLength).fill(defaultValue);
        }
        if (isPrepend && diff > 0) {
          return [...Array(diff).fill(defaultValue), ...prevArray];
        }
        if (isAppend && diff > 0) {
          return [...prevArray, ...Array(diff).fill(defaultValue)];
        }
        const nextArray = prevArray.slice(0, nextLength);
        while (nextArray.length < nextLength) {
          nextArray.push(defaultValue);
        }
        return nextArray;
      };

      setRequireReview((prev) => adjustArray(prev, false));
      setReviewNotes((prev) => adjustArray(prev, ''));
    }

    previousResultsRef.current = comparisonResults;
  }, [comparisonResults]);




  useEffect(() => {
    // console.log('useEffect - location', location);



    // Extract session_id from URL
    const params = new URLSearchParams(location.search);
    setSessionId(params.get('session_id'));
  }, [location]);
  
  
  useEffect(() => {

        // Initialize socket inside useEffect
      socket.current = io('https://api.pacificpearltraining.site/comparison');
      console.log('sessionId', sessionId, typeof sessionId);
    
    // Send session_id to backend for verification
    if (sessionId) {
      axios.get('https://api.pacificpearltraining.site/verify-session', {
        params: {
          session_id: sessionId
        }
      })
      .then(response => {
        // Handle response
        if (response.data.success) {
          console.log('Session ID is valid');
          // Store session ID in local storage
          localStorage.setItem('sessionId', sessionId);
          


          socket.current.on('connect', () => {
            setIsSocketConnected(true);
            socket.current.emit('message', JSON.stringify({ type: 'session_id', value: sessionId, sessionId:sessionId }));
          });


          socket.current.on('connect_error', (error) => {
            console.error('Connection Error:', error);
          });
      
          socket.current.on('connect_timeout', () => {
            console.error('Connection Timeout');
          });

          socket.current.on('comparisonResult', (event) => {
            // Handle incoming comparison result
            const parsedEvent = JSON.parse(event);

            // New trainee account: backend signals there are no orders yet.
            // Show onboarding instructions instead of trying to render empty data.
            if (parsedEvent && (parsedEvent.noOrdersYet || !parsedEvent.order1Data)) {
              console.log('No orders yet for this trainee - showing onboarding instructions', parsedEvent);
              setNeedsFirstOrder(true);
              setOnboardingInfo({
                customerId: parsedEvent.customerId,
                customerTags: parsedEvent.customerTags,
                restaurantName: parsedEvent.restaurantName || null,
              });
              setLoading(false);
              setRecivedComparisonResults(true);
              return;
            }
            // We have real data - make sure onboarding is cleared
            setNeedsFirstOrder(false);

            const processedOrder1 = simplifyingOrderData(parsedEvent.order1Data, parsedEvent.notMatchingInOrder1Data);
            const processedOrder2 = simplifyingOrderData(parsedEvent.order2Data, parsedEvent.notMatchingInOrder2Data);
            // console.log('processedOrder1',processedOrder1);
            // console.log('processedOrder2',processedOrder2);
            console.log('parsedEvent.GPTCompletionData',parsedEvent.GPTCompletionData);
            const sortedOrder1 = sortLineItems(processedOrder1.simplifiedOrder);
            const sortedOrder2 = sortLineItems(processedOrder2.simplifiedOrder);

            const processedComparisonResult = {
              order1Data: sortedOrder1,
              order2Data: sortedOrder2,
              notMatchingInOrder1Data: processedOrder1.notMatchingData,
              notMatchingInOrder2Data: processedOrder2.notMatchingData,
              customerId: parsedEvent.customerId,
              customerTags: parsedEvent.customerTags,
              restaurantName: parsedEvent.restaurantName || null,
              score: parsedEvent.score,
              unmatchedPenalty: parsedEvent.unmatchedPenalty,
              timePenalty: parsedEvent.timePenalty,
              GPTCompletionData:parsedEvent.GPTCompletionData
            };
          

            setComparisonResults(prevResults => {
              // Get the createdAt date from the new result
              const newResultDate = new Date(processedComparisonResult.order1Data.created_at);
            
              // Get the createdAt date from the last result
              const lastResultDate = prevResults.length > 0 ? new Date(prevResults[0].order1Data.created_at) : new Date(0);
            
              // If the new result is more recent, insert it at the beginning
              if (newResultDate > lastResultDate) {
                console.log("add processedComparisonResult to the beginning of ComparisonResults:",[processedComparisonResult, ...prevResults]);
                return [processedComparisonResult, ...prevResults];
              } else {
                // Else, append it at the end
                console.log("add processedComparisonResult to the end of ComparisonResults:",[...prevResults, processedComparisonResult]);
                return [...prevResults, processedComparisonResult];
              }

            });

            setLoading(false);
            console.log('recived compareisonResult:');
            console.dir(parsedEvent,{ depth: null });
            setRecivedComparisonResults(true);
          });

          socket.current.on('error', (error) => {
            console.error('Socket.IO error:', error);
          });

          socket.current.on('receiptPreview', (event) => {
            try {
              const parsed = JSON.parse(event);
              console.log('Received receiptPreview for order:', parsed.orderName, 'PrintNode Job ID:', parsed.printJobId);
              setReceiptPreviews(prev => [parsed, ...prev]);
            } catch (err) {
              console.error('Error parsing receiptPreview:', err);
            }
          });

          return () => {
            console.log('Close Socket.IO connection when component unmounts');
            socket.current.disconnect();
          };




        } else {
          console.log('Invalid session ID');
        }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
    }

    // Cleanup function
    return () => {
      if (socket.current) {
          // Disconnect from the socket
          socket.current.disconnect();

          // Set the current reference to null
          socket.current = null;
      }
    }
  }, [sessionId]);

  const loadMoreOrders = useCallback(() => {
    setLoading(true); // Start loading when the request begins.
    const lastOrderId = Number(comparisonResults[comparisonResults.length - 1].order1Data.id);
    const lastOrderData = {
      type: 'next_order', 
      lastOrderId: lastOrderId,
      customerId: comparisonResults[comparisonResults.length - 1].customerId,
      customerTags: comparisonResults[comparisonResults.length - 1].customerTags,
      sessionId: sessionId
    }
    console.log("loadMoreOrders Button - lastOrderData",lastOrderData);
    socket.current.emit('message', JSON.stringify(lastOrderData));
  }, [comparisonResults,sessionId]); // dependencies
  


  if (!comparisonResults) {
    return (
      <div>Waiting for data...</div>
    );
  }
  



  const captureScreenAndEmail = (index,order2Data,order1Data) => {
    console.log('captureScreenAndEmail called with index:', index); // Log index
    console.log('Current request statuses:', requestStatuses); // Log current statuses
    // Change the status to 'sending' for the clicked button
    const newStatuses = [...requestStatuses];
    newStatuses[index] = 'sending';
    setRequestStatuses(newStatuses);

    console.log('Updated request statuses:', newStatuses); // Log updated statuses

    // Concatenate the index with the ID to target the specific element
    const input = document.getElementById(`orderCapture-${index}`);

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');

        // // Open the image in a new window
        // const screenshotWindow = window.open('', '_blank');
        // const img = new Image();
        // img.src = imgData;
        // screenshotWindow.document.body.appendChild(img);

        // Split the data URL at the comma and get the base64 data
        const base64Data = imgData.split(",")[1];

        // Send the screenshot to the backend with trainee info
        sendScreenCapture(base64Data,index,order2Data,order1Data);
      });
  }


  const captureScreenAndCopy = async (index, order2Data, order1Data) => {
    const input = document.getElementById(`orderCapture-${index}`);
    console.log('captureScreenAndCopy-order2Data.id',order2Data);
    try {
      const canvas = await html2canvas(input);
      canvas.toBlob(async (blob) => {
        const item = new ClipboardItem({ 'image/png': blob });
        await navigator.clipboard.write([item]);
        updateCopyStatus('🎉 Copied, Now Paste in Your Signal Group'); // Success message
        setTimeout(() => updateCopyStatus('📸 Copy to Signal'), 5000); // Reset the text after 5 seconds
      });
    } catch (err) {
      console.error('Failed to copy image: ', err); // Error logging
      updateCopyStatus('😢 Oops! Something Went Wrong!'); // Failure message
      setTimeout(() => updateCopyStatus('📸 Copy to Signal'), 5000); // Reset the text after 5 seconds
    }

      // If a review is now required, capture the screen and email it
      if (requireReview[index]) {
        captureScreenAndEmail(index,order2Data,order1Data);
        handleReview(index);
      }
  }
  
  

  const sendScreenCapture = async (imgData,index,order2Data,order1Data) => {
    console.log('sendScreenCapture called with index:', index); // Log index

    // Get trainee info from order1Data (trainee's order)
    const traineeInfo = order1Data?.customer ? {
      firstName: order1Data.customer.first_name || '',
      lastName: order1Data.customer.last_name || '',
      email: order1Data.customer.email || '',
      customerId: order1Data.customer.id
    } : null;

    try {
      const response = await fetch('https://api.pacificpearltraining.site/emailScreenShot', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          imgData,
          orgiinalOrderId: order2Data.id,
          traineeInfo: traineeInfo,
          reviewNote: reviewNotes[index] || '',  // Include trainee's explanation
          originalOrder: order2Data,  // Original order data for AI analysis
          traineeOrder: order1Data    // Trainee's order entry for AI analysis
        })
      });
  
      if (response.ok) {
        console.log('Email sent successfully');
        // Change the status to 'sent' for the clicked button
        const newStatuses = [...requestStatuses];
        newStatuses[index] = 'sent';
        setRequestStatuses(newStatuses);
      } else {
        console.log('Email sending failed');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  

  const handleReview = (index) => {
    console.log('[ReviewModal v2] handleReview called for index:', index, 'requireReview:', requireReview[index]);
    if (!requireReview[index]) {
      // Requesting a review - open modal
      console.log('[ReviewModal v2] Opening modal...');
      setReviewModalIndex(index);
      setReviewModalNote('');
      setShowReviewModal(true);
    } else {
      // Removing review request
      const newRequireReview = [...requireReview];
      const newReviewNotes = [...reviewNotes];
      newReviewNotes[index] = '';
      newRequireReview[index] = false;
      setReviewNotes(newReviewNotes);
      setRequireReview(newRequireReview);
    }
  }

  const handleReviewModalSubmit = () => {
    if (reviewModalIndex === null) {
      setShowReviewModal(false);
      setReviewModalIndex(null);
      setReviewModalNote('');
      return;
    }
    if (reviewModalNote.trim() === '') {
      return; // Don't submit empty notes
    }

    const newRequireReview = [...requireReview];
    const newReviewNotes = [...reviewNotes];
    newReviewNotes[reviewModalIndex] = reviewModalNote.trim();
    newRequireReview[reviewModalIndex] = true;

    setReviewNotes(newReviewNotes);
    setRequireReview(newRequireReview);
    setShowReviewModal(false);
    setReviewModalIndex(null);
    setReviewModalNote('');
  }

  const handleReviewModalCancel = () => {
    setShowReviewModal(false);
    setReviewModalIndex(null);
    setReviewModalNote('');
  }




  // Function to toggle testing state
  const toggleAudioMixer = () => {
    setIsAudioMixer(!isAudioMixer);
  };
  






  return (
    
    <ShopifyProvider
    storeDomain={process.env.REACT_APP_PUBLIC_STORE_DOMAIN}
    storefrontToken={process.env.REACT_APP_PUBLIC_STOREFRONT_API_TOKEN}
    storefrontApiVersion="2023-10"
    countryIsoCode="US"
    languageIsoCode="EN"
    >
      <CartProvider
      onLineAdd={() => {
        console.log('onLineAdd - a line is being added');
      }}
      onLineAddComplete={() => {
        console.log('onLineAddComplete - a line has been added');
      }}
      >
    
        <div className="App">

          
        
          
            <Routes>
              <Route path="/" element={
                isAudioMixer ? <AudioMixer toggleAudioMixer={toggleAudioMixer} isAudioMixer={isAudioMixer} restaurantName={onboardingInfo?.restaurantName || comparisonResults[0]?.restaurantName || ''} /> : (
                  
                  <>
                    <button onClick={toggleAudioMixer} style={{ padding: '8px 16px', background: '#1565c0', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9em' }}>
                      Broadcast Audio to Restaurant
                    </button>

                    <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                        {(isSocketConnected && comparisonResults.length > 0) && <OrderToAudio socket={socket} comparisonResults={comparisonResults} recivedComparisonResults={recivedComparisonResults} setRecivedComparisonResults={setRecivedComparisonResults}sessionId={sessionId}/>}
                        {needsFirstOrder && comparisonResults.length === 0 ? (
                          <OnboardingCard>
                            <OnboardingTitle>👋 Welcome! Let's place your first practice order</OnboardingTitle>
                            <OnboardingSubtitle>
                              The Order Helper compares <strong>your practice orders</strong> against the matching real
                              orders from{' '}
                              <strong>
                                {onboardingInfo && onboardingInfo.restaurantName
                                  ? onboardingInfo.restaurantName
                                  : 'your restaurant'}
                              </strong>
                              . You don't have any practice orders yet, so there's nothing to compare.
                            </OnboardingSubtitle>
                            <OnboardingStepList>
                              <li>
                                Open the <strong>POS</strong> (button below).
                              </li>
                              <li>
                                Place a <strong>test order</strong> matching a real customer order — make sure to use
                                the same last name / phone as the real order.
                              </li>
                              <li>
                                Come back to the Order Helper — your order will show up here alongside the matching
                                real order for comparison.
                              </li>
                            </OnboardingStepList>
                            <OnboardingActions>
                              <OnboardingPrimaryButton
                                onClick={() => {
                                  const target = sessionId ? `/POS?session_id=${sessionId}` : '/POS';
                                  window.location.assign(target);
                                }}
                              >
                                Open POS to place a test order
                              </OnboardingPrimaryButton>
                              <OnboardingSecondaryButton onClick={() => window.location.reload()}>
                                I've placed an order — refresh
                              </OnboardingSecondaryButton>
                            </OnboardingActions>
                          </OnboardingCard>
                        ) : comparisonResults.length > 0 ? (
                          <div className="parentContainer">
                            <h2>Compare Orders:</h2>
                            {
                            comparisonResults.map((comparisonResult, index) => {
                              const { order1Data, order2Data, score, timePenalty, unmatchedPenalty, GPTCompletionData} = comparisonResult;
                              // const buttonText = requestStatuses[index] === 'idle' ? 'Request A Review'
                              // : requestStatuses[index] === 'sending' ? 'Sending Request...'
                              // : 'Request Sent';
                              return (
                                
                                order1Data && (
                                  
                                <CoolBorder key={index} $border={requireReview[index]}>

                                  <div key={index} id={`orderCapture-${index}`}>
                                  {requireReview[index] && <ReviewRequest>Requested Review</ReviewRequest>}
                                  {requireReview[index] && order1Data.customer && (
                                    <TraineeInfoContainer>
                                      <TraineeInfoText>👤 {order1Data.customer.first_name} {order1Data.customer.last_name}</TraineeInfoText>
                                      <TraineeInfoText>✉️ {order1Data.customer.email}</TraineeInfoText>
                                    </TraineeInfoContainer>
                                  )}
                                  {requireReview[index] && reviewNotes[index] && (
                                    <ReviewNoteContainer>
                                      <ReviewNoteTitle>📝 TRAINEE REVIEW NOTE:</ReviewNoteTitle>
                                      <ReviewNoteText>{reviewNotes[index]}</ReviewNoteText>
                                    </ReviewNoteContainer>
                                  )}
                                    <div className="tableContainer" style={requireReview[index] ? {border: '1px solid red'} : {}}>
                                      {order1Data && <OrderTableStyled><OrderTable orderData={order1Data} tableTitle="Your Order" realOrderData={order2Data} /></OrderTableStyled>}
                                      {order2Data && <OrderTableStyled><OrderTable orderData={order2Data} tableTitle="Real Order" /></OrderTableStyled>}
                                    </div>
                                    {GPTCompletionData && (
                                      <TranscriptContainer>
                                        <p style={{ color: '#d84315', fontSize: '16px' }}>🎧 What The Trainee Heard:</p>
                                        <p style={{ color: '#333', fontStyle: 'italic' }}>"{GPTCompletionData}"</p>
                                      </TranscriptContainer>
                                    )}
                                    
                                    {score !== null && score !== undefined && (
                                      <ScoreContainer>
                                        <ScoreHeading>Score: {score}</ScoreHeading>
                                        <ScoreDetail>Time Penalty: {timePenalty}</ScoreDetail>
                                        <ScoreDetail>Unmatched Penalty: {unmatchedPenalty}</ScoreDetail>
                                      </ScoreContainer>
                                    )}
                                  </div>
                                  
                                  {receiptPreviews.length > 0 && receiptPreviews.find(rp => rp.orderName === order1Data.name) && (
                                    <div style={{ margin: '15px 0', padding: '10px', backgroundColor: '#f0f8f0', borderRadius: '8px', border: '1px solid #c8e6c9' }}>
                                      <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#2e7d32' }}>🖨️ Receipt Sent to Test Printer (Job ID: {receiptPreviews.find(rp => rp.orderName === order1Data.name).printJobId})</p>
                                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div dangerouslySetInnerHTML={{ __html: receiptPreviews.find(rp => rp.orderName === order1Data.name).receiptHtml }} />
                                      </div>
                                    </div>
                                  )}
                                  <StyledButton onClick={() => captureScreenAndCopy(index, order2Data, order1Data)}>{copyStatusMessage}</StyledButton>
                                  <StyledButton onClick={() => handleReview(index)}>
                                    {requireReview[index] ? 'Remove Review Request' : 'Our system made a mistake? Click Here First'}
                                  </StyledButton>
                                  
                                  {/* <StyledButton onClick={() => captureScreenAndDownload(index)}>Download Screenshot</StyledButton> */}
                                  {/* <StyledButton onClick={() => captureScreenAndEmail(index)} disabled={requestStatuses[index] !== 'idle'}>
                                      {buttonText}
                                  </StyledButton> */}
                                </CoolBorder>
                              
                                )
                              );
                            })}
                            { !loading && <StyledButton onClick={loadMoreOrders} style={{ margin: '30px' }}>Load More Orders</StyledButton>}
                            {loading && <ClipLoader color={"#123abc"} loading={loading} css={override} size={150} />}
                          
                            {/* < TwilioPhone comparisonResults={comparisonResults} />   */}

                            
                          </div>
                        ) : (
                          <div>Loading...</div>
                        )}
                    </header>
                  </>
                )
              } />
              
              <Route path="/POS" element={<POSComponent customerTags={comparisonResults.length > 0 ? comparisonResults[0].customerTags : (onboardingInfo ? onboardingInfo.customerTags : '') } customerId={comparisonResults.length > 0 ? comparisonResults[0].customerId : (onboardingInfo ? onboardingInfo.customerId : '') } />} />
              
              <Route path="/score-checker/:orderId" element={<ScoreChecker />} />
              <Route path="/score-checker" element={<ScoreChecker />} />
            </Routes>

            {/* Review Note Modal */}
            {showReviewModal && (
              <ModalOverlay onClick={handleReviewModalCancel}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <ModalTitle>Request a Review</ModalTitle>
                  <ModalSubtitle>
                    Please explain what issue you noticed with this order. Your note will be visible to the reviewer.
                  </ModalSubtitle>
                  <ModalTextarea
                    value={reviewModalNote}
                    onChange={(e) => setReviewModalNote(e.target.value)}
                    placeholder="Example: The customer asked for no onions but I couldn't find a 'no onions' option in the system..."
                    autoFocus
                    maxLength={500}
                  />
                  <CharCount $warning={reviewModalNote.length > 450}>
                    {reviewModalNote.length}/500 characters
                  </CharCount>
                  <ModalButtonGroup>
                    <ModalButton onClick={handleReviewModalCancel}>
                      Cancel
                    </ModalButton>
                    <ModalButton
                      $primary
                      onClick={handleReviewModalSubmit}
                      disabled={reviewModalNote.trim() === ''}
                    >
                      Submit Review Request
                    </ModalButton>
                  </ModalButtonGroup>
                </ModalContent>
              </ModalOverlay>
            )}


        </div>
      </CartProvider>
    </ShopifyProvider>
  );

}






export default App;




//pacificpearltraining.site
